export default __webpack_public_path__ + "static/mybatis-2c95c3ac135f9d03469314d6e7e71245.png";